import { CustomTableColumn } from "./custom-table-column";

export class WorkOrderLinkTableColumn extends CustomTableColumn {

    constructor(label: string, path: string) {
        super("workOrderCode", label, path);
    }
}
